import React, { useState } from "react"
import { Navigate, useParams } from "react-router-dom"
import { useToast } from "~/utils/Toast"

import useFetchResource from "~/hooks/useFetchResource"
import getAppConfig from "~/utils/getAppConfig"
import { apiAreas } from "~/routes"

import PageContainer from "~/library/PageContainer"
import AreaForm from "~/components/AreaForm"
import LoadingWrapper from "~/library/LoadingWrapper"
import Area from "~/types/Area"

const EditArea = () => {
  const [isAreaUpdated, setIsAreaUpdated] = useState<boolean | null>(null)

  const { id } = useParams()
  const { venueSlug } = getAppConfig()
  const toast = useToast()

  const endpoint = apiAreas.show.path({ venue_slug: venueSlug, id })
  const { data: area, isLoading } = useFetchResource<{ area: Area }, "area">(endpoint, "area", {})

  const handleSubmit = (formValues: Area) => {
    const data = {
      venue_slug: venueSlug,
      id: area?.id,
      area: formValues,
    }

    const req = apiAreas.update({ data })
    req.then(() => {
      setIsAreaUpdated(true)
      toast("Area updated successfully", "success")
    })
    req.catch((res) => {
      toast(`Error updating Area. ${res.body.errors.join(", ")}`, "danger")
    })
  }

  if (isAreaUpdated) {
    return <Navigate to={`/areas/${area?.id}`} />
  }

  return (
    <PageContainer>
      <div className="row h-100">
        <div className="col-6 offset-3 align-center mt-4">
          <h3 className="mb-3">Edit Bookable Area</h3>
          <LoadingWrapper isLoading={isLoading}>
            <AreaForm onSubmit={handleSubmit} initialValues={area} isEditing={true} />
          </LoadingWrapper>
        </div>
      </div>
    </PageContainer>
  )
}

export default EditArea
